export default "__VITE_ASSET__CCfBvs94__"